/*
 * Actions types
 */
export enum CommonTypes {
  CATEGORIA_REQUEST = '@common/CATEGORIA_REQUEST',
  CATEGORIA_SUCCESS = '@common/CATEGORIA_SUCCESS',
  CATEGORIA_FAILURE = '@common/CATEGORIA_FAILURE',
  COMPANY_REQUEST = '@common/COMPANY_REQUEST',
  COMPANY_SUCCESS = '@common/COMPANY_SUCCESS',
  COMPANY_FAILURE = '@common/COMPANY_FAILURE',
  COMPANY_ALL_REQUEST = '@common/COMPANY_ALL_REQUEST',
  COMPANY_ALL_SUCCESS = '@common/COMPANY_ALL_SUCCESS',
  COMPANY_ALL_FAILURE = '@common/COMPANY_ALL_FAILURE',
}

/*
 * State Type
 */
export interface CommonState {
  readonly categorias: any;
  readonly company: any;
  readonly companyAll: any;
  readonly loading: boolean;
  readonly error: boolean;
}
